import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#374151",
      d: "M11.06 11.34c-.81.726-1.877 1.13-3.048 1.13-2.582 0-4.478-1.897-4.478-4.5 0-2.604 1.836-4.42 4.478-4.42 1.151 0 2.239.383 3.068 1.11l.563.484 2.503-2.502-.626-.566C12.047.746 10.09 0 8.01 0 3.371 0 0 3.349 0 7.95 0 12.53 3.451 16 8.011 16c2.12 0 4.095-.746 5.55-2.098l.605-.565-2.542-2.5z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#e62415",
      d: "M7.89 5.326a2.684 2.684 0 1 1 0 5.369 2.684 2.684 0 0 1 0-5.37"
    }, null, -1)
  ]))]))
}
export default { render: render }